/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import AvatarIcon from '../../AvatarIcon';
import StateLink from '../../StateLink';
import proNotifications from '../../../modules/proNotifications';

import './Notification.scss';
import './UserRequestedWaitlist.scss';
import { useIsMobile, useParams } from '../../../hooks';
import { CALENDAR_ROUTE, PROVIDER_WAITLIST_ROUTE } from '../../../route-names';

/**
 * User requested waitlist notification
 */
export default function UserRequestedWaitlist(props) {
  const { notification } = props;
  const isMobile = useIsMobile();
  const routeParams = useParams();
  const params = {
    ...routeParams,
    waitlistId: notification?.waitlist_id,
    clientRequested: true,
  };

  return (
    <StateLink
      to={isMobile ? PROVIDER_WAITLIST_ROUTE : CALENDAR_ROUTE}
      params={params}
      clickTracking={{
        name: 'pro_premiumappt_client_request_booknow_clicked',
        params: {
          waitlist_id: notification.waitlist_id,
          book_now_source: 'notification',
          premium_upgrade: notification.provider_premium_upcharge_rate,
        },
      }}
    >
      <section
        className="notification user-requested-waitlist"
        onClick={() => proNotifications.trackNotificationClick(notification)}
      >
        <div className="icon">
          <AvatarIcon
            icon={notification.thumbnail}
            name={notification.client_name}
            className="yellowBorder"
            sizeClass="with-border"
          />
        </div>
        <section className="notification-body short-block">
          <p className="notification-text short-text-ellipsis">
            <strong>
              Revenue boost!
            </strong>
            <span>
              &nbsp;{notification.client_name} wants to pay more for a Premium Appointment.
            </span>
          </p>
          <span className="from-now">
            RECEIVED {proNotifications.getFromNowDisplay(notification.creation_time)}
          </span>

          <p className="right-aligned-buttons">
            <span className="ss-button dark small span-btn">
              Book Now
            </span>
          </p>

        </section>
      </section>
    </StateLink>
  );
}

UserRequestedWaitlist.propTypes = {
  /** @type {Object} Notification object */
  notification: PropTypes.object.isRequired,
};
